import { render, staticRenderFns } from "./EmployeeLegajo.vue?vue&type=template&id=70b571e2"
import script from "./EmployeeLegajo.vue?vue&type=script&lang=js"
export * from "./EmployeeLegajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports